module.exports = __webpack_public_path__ + "media/theme/border-6-c1901d72.png";